module.exports = __webpack_public_path__ + "img/virtual_underline.9768448f.svg";